"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const StyleUtils_1 = require("../../utils/StyleUtils");
const Utils_1 = require("../../utils/Utils");
const Popover_styles_1 = require("./styles/Popover.styles");
const Popover = ({ children, className, fullWidth = false, onClose, onOpen, panelClassName, testId, trigger, }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const containerRef = (0, react_1.useRef)(null);
    const styles = (0, Popover_styles_1.getPopoverStyles)();
    const close = () => {
        setIsOpen(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    const handleToggle = () => {
        const next = !isOpen;
        setIsOpen(next);
        if (next)
            onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        else
            onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    (0, react_1.useEffect)(() => {
        const handleOutsideClick = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                close();
            }
        };
        if (isOpen) {
            document.addEventListener('mousedown', handleOutsideClick);
        }
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, [isOpen]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ ref: containerRef, className: (0, StyleUtils_1.classNames)('Popover-local', styles.container, fullWidth && styles.fullWidth, className) }, (0, Utils_1.getTestIdAttribute)(testId), { children: [trigger({ isOpen, onClick: handleToggle }), isOpen && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, StyleUtils_1.classNames)('Popover-panel-local', styles.panel, panelClassName) }, (0, Utils_1.getTestIdAttribute)('popover-panel'), { children: typeof children === 'function' ? children({ close }) : children })))] })));
};
exports.Popover = Popover;
